export const MFE_RUNTIME_STATUS = Object.freeze({
  LOADING: "loading",
  READY: "ready",
  FAILED: "failed",
});

export const MFE_RUNTIME_EVENTS = Object.freeze({
  INITIALIZED: "va:anchor:initialized",
  FAILED: "va:anchor:failed",
});

const STATUS_KEY = "_mfeRuntimeStatus";

export const getMFERuntimeStatus = () => window[STATUS_KEY];

export const setMFERuntimeStatus = (status) => {
  window[STATUS_KEY] = status;

  if (status === MFE_RUNTIME_STATUS.READY) {
    window.dispatchEvent(new Event(MFE_RUNTIME_EVENTS.INITIALIZED));
  }

  if (status === MFE_RUNTIME_STATUS.FAILED) {
    window.dispatchEvent(new Event(MFE_RUNTIME_EVENTS.FAILED));
  }
};
